import { formatCurrency } from '@/utils/formatters';
import type { DashboardData } from '../hooks/useDashboard';
import { InformationAsOfLabel } from '@/portal/shared/components';

export function WelcomeHeader({ data }: { data: DashboardData }) {
  const hasFunds = data.funds.length > 0;
  return (
    <div className="mb-8 flex items-start justify-between gap-4">
      <div>
        <h1 className="text-3xl font-bold text-foreground">
          Welcome back, {data.contact.first_name}.
        </h1>
        {hasFunds ? (
          <>
            {data.summary.holdings_published && (
              <p className="text-muted-foreground mt-1">
                Your total commitment with {data.contact.investor_name} stands
                at{' '}
                {formatCurrency(data.summary.total_commitment, {
                  currency: data.summary.base_currency,
                })}
                .
              </p>
            )}
            <InformationAsOfLabel
              date={data.summary.information_as_of}
              className="mt-2 shrink-0"
            />
          </>
        ) : (
          <p className="text-muted-foreground mt-1">
            {data.contact.investor_name} is not yet assigned to a fund.
          </p>
        )}
      </div>
    </div>
  );
}
